import * as React from 'react';
import { Button, IconSort16, UIText1 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { trackSortAnalyticClick } from './analytics/reviewsSortAnalytic';
import { getActiveSort, getSortOptions } from '../../selectors/sort';
import { setActiveSort } from '../../actions/sort';
import { ESortType } from '../../types/sort';
import { loadReviews } from '../../actions/reviews/loadReviews';
import { ReviewsSortLayout } from '../../components/ReviewsSort';
import { ReviewSortItem } from '../../components/ReviewsSort/parts';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { getActiveRatingFiltersValues, getActiveTagFiltersValue } from '../../selectors/filters';
import { loadQuestions } from '../../actions/questions';

export const ReviewsSortContainer: React.FC = () => {
  const dispatch = useDispatch();

  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const { custom } = useApplicationContext();

  const siteType = custom.deviceType;
  const rating = useSelector(getNewbuildingRating);
  const reviewRate = useSelector(getActiveRatingFiltersValues);
  const activeTag = useSelector(getActiveTagFiltersValue);

  const sortOptions = useSelector(getSortOptions);
  const activeSort = useSelector(getActiveSort);

  const [isOpen, setOpen] = React.useState<boolean>(false);

  const handleDropdownClick = useCallback(() => {
    setOpen(!isOpen);
  }, [setOpen, isOpen]);

  const handleDropdownClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleChangeSortType = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleDropdownClose();

      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          filter_rating: reviewRate,
          filter_sort: event.target.value,
          filter_tag: activeTag,
        },
      };
      trackSortAnalyticClick({ page });
      dispatch(setActiveSort(event.target.value as ESortType));
      dispatch(loadReviews());
      dispatch(loadQuestions());
    },
    [setActiveSort, loadReviews, loadQuestions, dispatch, sortOptions],
  );

  return (
    <ReviewsSortLayout
      title={<UIText1 color="black_100">Сортировать:</UIText1>}
      sortButton={
        <Button
          size="XS"
          theme="fill_white_primary"
          beforeIcon={<IconSort16 color="primary_100" />}
          onClick={handleDropdownClick}
        >
          {isMobile ? '' : activeSort?.title || 'По умолчанию'}
        </Button>
      }
      isOpen={isOpen}
      onClose={handleDropdownClose}
    >
      <>
        {sortOptions.map(({ type, title, isSelected }) => (
          <ReviewSortItem key={type} type={type} title={title} isSelected={isSelected} onClick={handleChangeSortType} />
        ))}
      </>
    </ReviewsSortLayout>
  );
};
